import type { HttpInterceptorFn } from '@angular/common/http';
import { HttpContext, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@core/services/ui/loading.service';
import { finalize, timeout, throwError, catchError } from 'rxjs';

export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

export function omitirCargaGlobal(): HttpContext {
  return new HttpContext().set(SKIP_LOADING, true);
}

const TIMEOUT_PETICION_MS = 30000;

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  loadingService.iniciarPeticion();

  return next(req).pipe(
    timeout(TIMEOUT_PETICION_MS),
    catchError((error) => {
      if (error?.name === 'TimeoutError') {
        return throwError(() => ({
          status: 408,
          statusText: 'Request Timeout',
          error: { message: 'No se pudo completar la operación. Por favor, intenta nuevamente.' },
          url: req.url,
        }));
      }
      return throwError(() => error);
    }),
    finalize(() => loadingService.finalizarPeticion()),
  );
};
